import { render, staticRenderFns } from "./ModalContents.vue?vue&type=template&id=43d934c4&scoped=true&"
import script from "./ModalContents.vue?vue&type=script&lang=js&"
export * from "./ModalContents.vue?vue&type=script&lang=js&"
import style0 from "./ModalContents.vue?vue&type=style&index=0&id=43d934c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d934c4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
